import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { observer } from 'mobx-react';

import classes from './Image.module.scss';

export type ImageProps = JSX.IntrinsicElements['div'] & {
    src: any;
    alt?: string;
    imageClass?: string;
    type?: string;
    useLazy?: boolean;
    placeholder?: string;
    onClick?: VoidFunction;
    onLoad?: VoidFunction;
};

export default observer<React.FC<ImageProps>>(function Image({
    src,
    alt = '',
    className = '',
    imageClass = '',
    type = '',
    useLazy = false,
    placeholder,
    onClick,
    onLoad,
}) {
    const url = typeof src === 'string' ? src : src?.src;
    if (src && src !== 'undefined') {
        if (Array.isArray(src)) {
            const srcDefault = src[0];
            src.slice(0, 1);
            return (
                <div
                    className={`${classes.image} ${className && classes[className]} ${type}`}
                    onClick={onClick}
                >
                    <picture onLoad={onLoad}>
                        {src.map((img) => (
                            <source
                                key={img.src}
                                srcSet={url + img.src}
                                media={`(max-width: ${img.media})`}
                            />
                        ))}
                        <img src={url + srcDefault.src} alt={alt} />
                    </picture>
                </div>
            );
        }
        return (
            <div className={`${classes.image} ${className} ${type}`} onClick={onClick}>
                {useLazy ? (
                    <LazyLoadImage
                        alt={alt}
                        src={url}
                        effect="blur"
                        // placeholder={<img alt={alt} src={url + placeholder} />}
                        // placeholderSrc={placeholder ? url + placeholder : ''}
                    />
                ) : (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                        src={url}
                        className={imageClass || ''}
                        alt={alt}
                        title={alt}
                        onLoad={onLoad}
                        onClick={onClick}
                    />
                )}
            </div>
        );
    }
    return null;
});
